import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTPARAMETERSMODAL_LEGACY_FIELD_ORDER = [
  "display_asap_for_later_picker"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartParametersModalDescriptor: _generatedCartParametersModalDescriptor,
  cartParametersModalModalDefinition,
  cartParametersModalDashboardLayout,
  cartParametersModalConfig,
  cartParametersModalResolveConfig,
  cartParametersModalProperties,
} = doodModalConfig(
  {
    name: "Cart parameters modal",
    handle: "cart-parameters-modal",
    internal_name: "CartParametersModal",
    componentType: 'CartParametersModalComponent',
    category: 'modal',
    description: "Cart parameters modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "cart-parameters-modal",
    sharedFields: {}
  },

  () => ({
    display_asap_for_later_picker: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        "label": "Display ASAP/Later picker"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["display_asap_for_later_picker"],
          },
        ],
      },
    ],
  })
);

export function cartParametersModalDescriptor(): IBlockDescriptor;
export function cartParametersModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartParametersModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartParametersModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartParametersModalDescriptor, cartParametersModalProperties, fieldOrder);
}

export {
  cartParametersModalModalDefinition,
  cartParametersModalDashboardLayout,
  cartParametersModalProperties,
  cartParametersModalConfig,
  cartParametersModalResolveConfig,
};

export type CartParametersModalConfig = typeof cartParametersModalConfig;
